import {
  TGetTransactionsData,
  TransactionTypeEnum,
  IBankTransaction,
  IPurchaseTransaction,
  TransactionData
} from '@/services/types/TransactionData';

export const getTransactionAmount = (transaction: TGetTransactionsData) => {
  switch (transaction.type) {
    case TransactionTypeEnum.Bank:
    case TransactionTypeEnum.Transfer:
    case TransactionTypeEnum.Admin:
    case TransactionTypeEnum.TopUp:
    case TransactionTypeEnum.Interest:
    case TransactionTypeEnum.Tax:
    case TransactionTypeEnum.Return:
    case TransactionTypeEnum.Investment:
    case TransactionTypeEnum.EmergePay: {
      const data = transaction.data as TransactionData & Pick<IBankTransaction, 'amount'>;
      return {
        sign: data.sign,
        amount: data.amount
      };
    }
    case TransactionTypeEnum.Purchase: {
      const data = transaction.data as IPurchaseTransaction;
      return {
        sign: data.sign,
        amount: data.billingAmount
      };
    }
  }
};
